import { FC } from 'react'
import { alpha, Box, Dialog, IconButton, paperClasses, styled } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import DownloadTranscriptButton from './DownloadTranscriptButton'

interface Props {
  iframeHtml: string
  open: boolean
  onClose: () => void
  wistiaId?: string | null
  questionNumber?: number
}

const VideoModal: FC<Props> = ({ iframeHtml, open, onClose, wistiaId, questionNumber }) => {
  return (
    <StyledDialog open={open} onClose={onClose}>
      <StyledCloseButton autoFocus disableRipple size='large' onClick={onClose} aria-label="Close Video">
        <CloseIcon icon={faTimes} />
      </StyledCloseButton>
      <IframeContainer dangerouslySetInnerHTML={{ __html: iframeHtml }} />
      {wistiaId && (
        <DownloadTranscriptFooter>
          <DownloadTranscriptButton wistiaId={wistiaId} questionNumber={questionNumber} />
        </DownloadTranscriptFooter>
      )}
    </StyledDialog>
  )
}

const DownloadTranscriptFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  padding: theme.spacing(3, 0, 0),
}))

const StyledDialog = styled(Dialog)(() => ({
  [`& .${paperClasses.root}`]: {
    position: 'relative',
    width: '80vw',
    maxWidth: '1200px',
    aspectRatio: '16 / 9',
    height: 'auto',
    overflow: 'visible',
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
}))

const IframeContainer = styled(Box)(() => ({
  width: '100%',
  height: '100%',

  '& iframe': {
    width: '100%',
    height: '100%',
    border: 'none',
  },
}))

const StyledCloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  width: '40px',
  height: '40px',
  zIndex: 1000,
  top: '0px',
  right: '-45px',
  backgroundColor: alpha(theme.palette.grey[800], 0.6),
  border: `1px solid ${theme.palette.common.white}`,

  '&:hover': {
    backgroundColor: theme.palette.grey[800],
  },
}))

const CloseIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: '1.25rem',
  color: theme.palette.common.white,
  transition: theme.transitions.create(['color']),
}))

export default VideoModal
